import React from 'react';
import {
  Blocking,
  Point10,
  Point5,
  Point7,
  SpecialWrapper,
  Sub,
  Table,
  TeamName
} from './styled';
import { observer } from 'mobx-react';

const BoxScore = observer(({ detail }) => {
  const { teams, periodSpecial } = detail;

  const homeTeam = teams.home;
  const awayTeam = teams.away;

  return (
    <Table>
      <colgroup>
        <col width={147} />
        <col />
        <col />
        <col />
        <col />
        <col />
        <col />
      </colgroup>
      <thead>
        <tr>
          <th></th>
          <th>1set</th>
          <th>2set</th>
          <th>3set</th>
          <th>4set</th>
          <th>5set</th>
          <th>총합</th>
        </tr>
      </thead>
      <tbody>
        <TeamRow
          teamData={awayTeam}
          position={'AWAY'}
          periodSpecial={periodSpecial}
          detail={detail}
        />
        <TeamRow
          teamData={homeTeam}
          position={'HOME'}
          periodSpecial={periodSpecial}
          detail={detail}
        />
      </tbody>
      <tfoot>
        <tr>
          <th></th>
          <td>{detail.periodScore[1] || null}</td>
          <td>{detail.periodScore[2] || null}</td>
          <td>{detail.periodScore[3] || null}</td>
          <td>{detail.periodScore[4] || null}</td>
          <td>{detail.periodScore[5] || null}</td>
          <td>{detail.summaryScore}</td>
        </tr>
      </tfoot>
    </Table>
  );
});

const TeamRow = ({ teamData, position, detail }) => {
  const { periodSpecial } = detail;
  const { periodData, name } = teamData;
  let totalScore = 0;
  if (position === 'HOME') {
    totalScore = detail.homeTotalScore;
  } else {
    totalScore = detail.awayTotalScore;
  }

  return (
    <tr>
      <th>
        {name}
        <TeamName position={position} />
      </th>
      <td>
        {periodData[0] && periodData[0].score}
        <Special specialData={periodSpecial[0] || null} position={position} />
      </td>
      <td>
        {periodData[1] && periodData[1].score}
        <Special specialData={periodSpecial[1] || null} position={position} />
      </td>
      <td>
        {periodData[2] && periodData[2].score}
        <Special specialData={periodSpecial[2] || null} position={position} />
      </td>
      <td>
        {periodData[3] && periodData[3].score}
        <Special specialData={periodSpecial[3] || null} position={position} />
      </td>
      <td>{periodData[4] && periodData[4].score}</td>
      <td>{totalScore}</td>
    </tr>
  );
};

const Special = ({ specialData, position }) => {
  let specialComps = [];
  if (specialData !== null) {
    const {
      firstBlocking,
      firstServePoint,
      firstFive,
      firstSeven,
      firstTen
    } = specialData;
    if (firstServePoint === position) {
      specialComps.push(<Sub key={'sub'} />);
    }
    if (firstBlocking === position) {
      specialComps.push(<Blocking key={'blocking'} />);
    }
    if (firstFive === position) {
      specialComps.push(<Point5 key={'firstFive'} />);
    }
    if (firstSeven === position) {
      specialComps.push(<Point7 key={'firstSeven'} />);
    }
    if (firstTen === position) {
      specialComps.push(<Point10 key={'firstTen'} />);
    }
  }
  return <SpecialWrapper>{specialComps}</SpecialWrapper>;
};

export default BoxScore;
